<template>
    <div>
        <div class="listing-header mb-4" v-if="planosafra.situacao == 4">
            <div class="title-breadcrumb">
                <div class="header-buttons">
                    <button
                        v-if="(!isUpdate && permissao.create) || (isUpdate && permissao.update)"
                        @click="save(4)"
                        :disabled="
                            planosafra.hasagrovisita || isSaving || cantEdit || isLoadingEdit
                        "
                        class="save-btn"
                        type="button"
                    >
                        {{ $t('salvar') }}
                        <button-loader :isSaving="isSaving" />
                    </button>
                </div>
            </div>
        </div>
        <div class="page-container form-columns-fit mt-4 mb-4">
            <div class="columns is-flex-wrap">
                <div class="column is-6">
                    <vss-select
                        :id="generateId(1)"
                        ref="empresaInput"
                        title="empresa"
                        placeholder="selecione"
                        :options="empresaSelect"
                        v-model="empresaSelected"
                        msg="msg-campo-obrigatorio"
                        :required="true"
                        :invalid="empresaSelected == null"
                        :loading="empresasLoading"
                        @onBlurFunction="sendIsChanged('empresa')"
                        searchable
                        :disabled="planosafra.hasagrovisita || cantEdit || isLoadingEdit"
                        @search="carregarEmpresas"
                    />
                </div>
                <div class="column is-6">
                    <vss-select
                        :id="generateId(2)"
                        ref="clienteInput"
                        title="cliente"
                        :placeholder="
                            clienteSelect.length > 0
                                ? 'selecione-uma-opcao'
                                : 'sem-opcao-de-selecao'
                        "
                        :options="clienteSelect"
                        v-model="clienteSelected"
                        msg="msg-campo-obrigatorio"
                        :required="true"
                        :invalid="clienteSelected == null"
                        invalidWhenDisabled
                        :loading="clienteLoading"
                        @onBlurFunction="sendIsChanged('cliente')"
                        @search="carregarCliente"
                        searchable
                        :disabled="
                            planosafra.hasagrovisita ||
                            empresaSelected == null ||
                            cantEdit ||
                            isLoadingEdit
                        "
                    />
                </div>
                <div class="column is-6">
                    <vss-select
                        :id="generateId(3)"
                        ref="safraInput"
                        title="safra"
                        placeholder="selecione"
                        :options="safraSelect"
                        v-model="safraSelected"
                        msg="msg-campo-obrigatorio"
                        :required="true"
                        :invalid="safraSelected == null"
                        :loading="safraLoading"
                        @onBlurFunction="sendIsChanged('safra')"
                        @search="carregarSafra"
                        searchable
                        :disabled="planosafra.hasagrovisita || cantEdit || isLoadingEdit"
                    />
                </div>
                <div class="column is-6">
                    <vss-select
                        :id="generateId(4)"
                        ref="culturaInput"
                        title="cultura"
                        placeholder="selecione"
                        :options="culturaSelect"
                        v-model="culturaSelected"
                        msg="msg-campo-obrigatorio"
                        :required="true"
                        :invalid="culturaSelected == null"
                        invalidWhenDisabled
                        :loading="culturaLoading"
                        @onBlurFunction="sendIsChanged('cultura')"
                        @search="carregarCultura"
                        searchable
                        tooltipLabel="informacao-cultura-planosafra"
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="
                            planosafra.hasagrovisita ||
                            empresaSelected == null ||
                            safraSelected == null ||
                            cantEdit ||
                            isLoadingEdit
                        "
                    />
                </div>
            </div>
        </div>
        <div class="page-container form-columns-fit mt-4 mb-4" v-if="showFields">
            <div class="columns is-flex-wrap flex-end">
                <div class="column is-6" v-if="permissaoFields.ativaniveltecnologico > 0">
                    <vss-select
                        :id="generateId(5)"
                        ref="niveltecnologicoInput"
                        title="agro-niveltecnologico"
                        placeholder="selecione"
                        :options="niveltecnologicoSelect"
                        v-model="niveltecnologicoSelected"
                        :required="permissaoFields.ativaniveltecnologico == 2"
                        :invalid="
                            permissaoFields.ativaniveltecnologico == 2
                                ? niveltecnologicoSelected == null
                                : false
                        "
                        :loading="niveltecnologicoLoading"
                        @onBlurFunction="sendIsChanged('niveltecnologico')"
                        @search="carregarNivelTecnologico"
                        searchable
                        :disabled="planosafra.hasagrovisita || cantEdit || isLoadingEdit"
                    />
                </div>
                <div class="column is-6" v-if="permissaoFields.ativacultivar > 0">
                    <vss-select
                        :id="generateId(6)"
                        ref="cultivarInput"
                        title="cultivar"
                        placeholder="selecione"
                        :options="cultivarSelect"
                        v-model="cultivarSelected"
                        msg="msg-campo-obrigatorio"
                        :required="permissaoFields.ativacultivar == 2"
                        :invalid="
                            permissaoFields.ativacultivar == 2 ? cultivarSelected == null : false
                        "
                        :loading="cultivarLoading"
                        @onBlurFunction="sendIsChanged('cultivar')"
                        @search="carregarCultivar"
                        searchable
                        :disabled="planosafra.hasagrovisita || cantEdit || isLoadingEdit"
                    />
                </div>
                <div class="column is-6" v-if="permissaoFields.ativadatasemeadura > 0">
                    <verified-date-picker
                        :id="generateId(9)"
                        ref="dataInput"
                        placeholder="selecione-uma-data"
                        title="data-semeadura"
                        v-model="planosafra.datasemeadura"
                        :required="permissaoFields.ativadatasemeadura == 2"
                        :invalid="
                            permissaoFields.ativadatasemeadura == 2
                                ? isNull(planosafra.datasemeadura)
                                : false
                        "
                        :subtractDateYears="100"
                        :addDateYears="100"
                        :yearsRange="[-100, 100]"
                        :inForm="true"
                        @input="getStartDateColheita"
                        :disabled="planosafra.hasagrovisita || cantEdit || isLoadingEdit"
                    />
                </div>
                <div class="column is-6" v-if="permissaoFields.ativaformulaadubacao > 0">
                    <label
                        for="formula-adubacao"
                        v-text="
                            $t('formula-adubacao') +
                            (permissaoFields.ativaformulaadubacao == 2 ? ' *' : '')
                        "
                        :class="permissaoFields.ativaformulaadubacao == 2 ? 'label-required' : ''"
                    />
                    <div class="columns">
                        <div class="column is-1 mt-3" style="text-align: right">
                            <span> N </span>
                        </div>
                        <div class="column is-3 mt-2">
                            <v-input
                                :id="generateId(10)"
                                ref="formulaadubacaoNInput"
                                v-model="formulaadubacao.n"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                msg="msg-campo-obrigatorio"
                                :required="permissaoFields.ativaformulaadubacao == 2"
                                :invalid="
                                    permissaoFields.ativaformulaadubacao == 2
                                        ? !formulaadubacao.n
                                        : false
                                "
                                uppercase
                                :disabled="planosafra.hasagrovisita || cantEdit || isLoadingEdit"
                                v-mask="['##']"
                            />
                        </div>
                        <div class="column is-1 mt-3" style="text-align: right">
                            <span>P</span>
                        </div>
                        <div class="column is-3 mt-2">
                            <v-input
                                :id="generateId(10)"
                                ref="formulaadubacaoPInput"
                                v-model="formulaadubacao.p"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                msg="msg-campo-obrigatorio"
                                :required="permissaoFields.ativaformulaadubacao == 2"
                                :invalid="
                                    permissaoFields.ativaformulaadubacao == 2
                                        ? !formulaadubacao.p
                                        : false
                                "
                                uppercase
                                :disabled="planosafra.hasagrovisita || cantEdit || isLoadingEdit"
                                v-mask="['##']"
                            />
                        </div>
                        <div class="column is-1 mt-3" style="text-align: right">
                            <span>K</span>
                        </div>
                        <div class="column is-3 mt-2">
                            <v-input
                                :id="generateId(10)"
                                ref="formulaadubacaoKInput"
                                v-model="formulaadubacao.k"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                msg="msg-campo-obrigatorio"
                                :required="permissaoFields.ativaformulaadubacao == 2"
                                :invalid="
                                    permissaoFields.ativaformulaadubacao == 2
                                        ? !formulaadubacao.k
                                        : false
                                "
                                uppercase
                                :disabled="planosafra.hasagrovisita || cantEdit || isLoadingEdit"
                                v-mask="['##']"
                            />
                        </div>
                    </div>
                </div>
                <div class="column is-6" v-if="permissaoFields.ativaqtdeadubacao > 0">
                    <v-input
                        :id="generateId(11)"
                        ref="qtdeadubacaoInput"
                        v-model.number="planosafra.qtdeadubacao"
                        placeholder="placeholder-preencha"
                        :maxlength="50"
                        title="qtde-adubacao"
                        msg="msg-campo-obrigatorio"
                        :required="permissaoFields.ativaqtdeadubacao == 2"
                        :invalid="
                            permissaoFields.ativaqtdeadubacao == 2
                                ? !planosafra.qtdeadubacao
                                : false
                        "
                        uppercase
                        validchars="0123456789.,"
                        :min="0"
                        :disabled="planosafra.hasagrovisita || cantEdit || isLoadingEdit"
                    />
                </div>
                <div class="column is-6" v-if="permissaoFields.ativaplantasmetroquadrado > 0">
                    <v-input
                        :id="generateId(12)"
                        ref="plantasmetroquadradoInput"
                        v-model.number="planosafra.plantasmetroquadrado"
                        placeholder="placeholder-preencha"
                        :maxlength="50"
                        title="plantas-metro-quadrado"
                        msg="msg-campo-obrigatorio"
                        :required="permissaoFields.ativaplantasmetroquadrado == 2"
                        :invalid="
                            permissaoFields.ativaplantasmetroquadrado == 2
                                ? isNull(planosafra.plantasmetroquadrado)
                                : false
                        "
                        validchars="0123456789"
                        :min="0"
                        :disabled="planosafra.hasagrovisita || cantEdit || isLoadingEdit"
                    />
                </div>
                <div class="column is-6" v-if="permissaoFields.ativaareatotalplantio > 0">
                    <v-input
                        :id="generateId(15)"
                        ref="areatotalplantioInput"
                        v-model.number="planosafra.areatotalplantio"
                        placeholder="placeholder-preencha"
                        :maxlength="50"
                        title="area-total-plantio"
                        msg="msg-campo-obrigatorio"
                        :required="permissaoFields.ativaareatotalplantio == 2"
                        :invalid="
                            permissaoFields.ativaareatotalplantio == 2
                                ? isNull(planosafra.areatotalplantio)
                                : false
                        "
                        validchars="0123456789"
                        :min="0"
                        :disabled="planosafra.hasagrovisita || cantEdit || isLoadingEdit"
                    />
                </div>
                <div class="column is-6" v-if="permissaoFields.ativaprevisaoproducao > 0">
                    <v-input
                        :id="generateId(8)"
                        ref="previsaoprodutoInput"
                        v-model.number="planosafra.previsaoproducao"
                        placeholder="placeholder-preencha"
                        :maxlength="50"
                        title="previsao-producao"
                        msg="msg-campo-obrigatorio"
                        :required="permissaoFields.ativaprevisaoproducao == 2"
                        :invalid="
                            permissaoFields.ativaprevisaoproducao == 2
                                ? isNull(planosafra.previsaoproducao)
                                : false
                        "
                        validchars="0123456789"
                        :min="0"
                        :disabled="planosafra.hasagrovisita || cantEdit || isLoadingEdit"
                    />
                </div>
                <div class="column is-6" v-if="permissaoFields.ativadatacolheita > 0">
                    <verified-date-picker
                        :id="generateId(16)"
                        ref="dataColheitaInput"
                        placeholder="selecione-uma-data"
                        title="data-colheita"
                        v-model="planosafra.datacolheita"
                        :required="permissaoFields.ativadatacolheita == 2"
                        :invalid="
                            permissaoFields.ativadatacolheita == 2
                                ? isNull(planosafra.datacolheita)
                                : false
                        "
                        :subtractDateYears="100"
                        :addDateYears="100"
                        :yearsRange="[-100, 100]"
                        :inForm="true"
                        :dateType="'endDate'"
                        :startDate="startDateColheita"
                        :disabled="planosafra.hasagrovisita || cantEdit || isLoadingEdit"
                    />
                </div>
                <div class="column is-6" v-if="permissaoFields.ativaprodutividadeobtida > 0">
                    <v-input
                        :id="generateId(17)"
                        ref="produtividadeObtidaInput"
                        v-model.number="planosafra.produtividadeobtida"
                        placeholder="placeholder-preencha"
                        :maxlength="50"
                        title="produtividade-obtida"
                        msg="msg-campo-obrigatorio"
                        :required="permissaoFields.ativaprodutividadeobtida == 2"
                        :invalid="
                            permissaoFields.ativaprodutividadeobtida == 2
                                ? isNull(planosafra.produtividadeobtida)
                                : false
                        "
                        validchars="0123456789"
                        :min="0"
                        :disabled="planosafra.hasagrovisita || cantEdit || isLoadingEdit"
                    />
                </div>
            </div>
            <div class="columns is-flex-wrap">
                <div class="column is-12 remove-padding">
                    <div class="column is-2" v-if="permissaoFields.ativacolunaespaco > 0">
                        <b-icon pack="fas" icon="spa" size="is-large" type="is-primary" />
                        <div class="linhaV" />
                        <v-input
                            :id="generateId(13)"
                            ref="colunaespacoInput"
                            v-model.number="planosafra.colunaespaco"
                            placeholder="placeholder-preencha"
                            title="coluna-espaco"
                            :maxlength="50"
                            msg="msg-campo-obrigatorio"
                            :required="permissaoFields.ativacolunaespaco == 2"
                            :invalid="
                                permissaoFields.ativacolunaespaco == 2
                                    ? isNull(planosafra.colunaespaco)
                                    : false
                            "
                            validchars="0123456789"
                            :min="0"
                            :disabled="planosafra.hasagrovisita || cantEdit || isLoadingEdit"
                            class="mb-2"
                        />
                        <div class="linhaV" />
                    </div>
                </div>
                <div
                    class="linhaM"
                    v-if="
                        permissaoFields.ativalinhaespaco > 0 ||
                        permissaoFields.ativacolunaespaco > 0
                    "
                >
                    <b-icon class="pt-4" pack="fas" icon="spa" size="is-large" type="is-primary" />
                </div>
                <div class="linhaH" v-if="permissaoFields.ativalinhaespaco > 0" />
                <div class="column is-2 mgr-large" v-if="permissaoFields.ativalinhaespaco > 0">
                    <v-input
                        :id="generateId(14)"
                        class="small-add-spacing"
                        ref="linhaespacoInput"
                        v-model.number="planosafra.linhaespaco"
                        placeholder="placeholder-preencha"
                        title="linha-espaco"
                        :maxlength="50"
                        msg="msg-campo-obrigatorio"
                        :required="permissaoFields.ativalinhaespaco == 2"
                        :invalid="
                            permissaoFields.ativalinhaespaco == 2
                                ? isNull(planosafra.linhaespaco)
                                : false
                        "
                        validchars="0123456789"
                        :min="0"
                        :disabled="planosafra.hasagrovisita || cantEdit || isLoadingEdit"
                    />
                </div>
                <div class="linhaH" v-if="permissaoFields.ativalinhaespaco > 0" />
                <div
                    class="column is-2 mgl-medium small-add-spacing-img"
                    v-if="permissaoFields.ativalinhaespaco > 0"
                >
                    <b-icon class="pt-4" pack="fas" icon="spa" size="is-large" type="is-primary" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EmpresaService from '@/services/vendas/empresa/EmpresaService';
import PlanoSafraService from '@/services/agro/planosafra/PlanoSafraService';
import PlanoSafraValidation from '@/services/validations/PlanoSafraValidation';
import VendasClienteService from '@/services/VendasClienteService';
import NivelTecnologicoService from '@/services/agro/nivel-tecnologico/NivelTecnologicoService';
import CultivarService from '@/services/agro/CultivarService';
import CulturaService from '@/services/agro/CulturaService';
import SafraService from '@/services/agro/SafraService';

/* @71170 - Dados cadastrais de planjemaneto de safra */
export default {

    props: {
        isUpdate: {
            type: Boolean,
            default: false,
        },
        cantEdit: {
            type: Boolean,
            default: false,
        },
        updateSituacao: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isLoading: false,
            isSaving: false,
            isChanged: false,
            isLoadingEdit: false,

            empresaService: new EmpresaService(this.$http, this.$router),
            service: new PlanoSafraService(this.$http, this.$router),
            clientservice: new VendasClienteService(this.$http, this.$router),
            safraservice: new SafraService(this.$http, this.$router),
            niveltecnologicoservice: new NivelTecnologicoService(this.$http, this.$router),
            cultivarService: new CultivarService(this.$http, this.$router),
            culturaService: new CulturaService(this.$http, this.$router),
            validation: new PlanoSafraValidation(this.msgs),
            planosafra: {
                idagro_planosafraerp: null,
                uuid: null,
                situacao: 4,
                latitude: null,
                longitude: null,
                lastfix: null,
                tipogps: null,
                previsaoproducao: null,
                datasemeadura: null,
                qtdeadubacao: null,
                colunaespaco: null,
                linhaespaco: null,
                plantasmetroquadrado: null,
                formulaadubacao: null,
                origem: null,
                datahora: null,
                replicapda: null,
                areatotalplantio: null,
                datacolheita: null,
                produtividadeobtida: null,
                // ligações
                idempresa: null,
                idcliente: null,
                idusuario: null,
                idagrosafra: null,
                idtipocultura: null,
                idcultivar: null,
                idagroniveltecnologico: null,
                // Models
                empresa: null,
                cultivar: null,
                safra: null,
                tipocultura: null,
                cliente: null,
                niveltecnologico: null,
                hasagrovisita: false,
            },
            formulaadubacao: {
                n: null,
                p: null,
                k: null,
            },
            permissao: {},
            // Controle de Cultura
            culturaSelect: [],
            culturaSelected: null,
            culturaLoading: false,
            // Controle de Cultivar
            cultivarSelect: [],
            cultivarSelected: null,
            cultivarLoading: false,
            // Controle de Safra
            safraSelect: [],
            safraSelected: null,
            safraLoading: false,
            // Controle de Empresa
            empresaSelect: [],
            empresaSelected: null,
            // Controle de cliente
            clienteSelect: [],
            clienteSelected: null,
            clienteLoading: false,
            // Controle de Nível tecnológico
            niveltecnologicoSelect: [],
            niveltecnologicoSelected: null,
            niveltecnologicoLoading: false,

            //valores para verificar qual das combobox/input aparece/são obrigatórias conforme a cultura selecionada
            permissaoFields: {
                ativacultivar: 0,
                ativaniveltecnologico: 0,
                ativadatasemeadura: 0,
                ativaqtdeadubacao: 0,
                ativaformulaadubacao: 0,
                ativaplantasmetroquadrado: 0,
                ativaareatotalplantio: 0,
                ativaprevisaoproducao: 0,
                ativadatacolheita: 0,
                ativaprodutividadeobtida: 0,
                ativalinhaespaco: 0,
                ativacolunaespaco: 0,
            },
            permissaoFieldsClean: {},
            showFields: false,

            // Validação de carregamento de dados na edição
            countToLoad: 0,
            countLoaded: 0,
            startDateColheita: this.$moment().add(-10, 'years').toDate(),
            empresasLoading: false,
        };
    },
    created() {
        if (this.isUpdate) {
            // caso seja update inicia validação de carregamento dos dados
            this.isLoadingEdit = true;
        }

        this.isChanged = false;
        this.permissaoFieldsClean = Object.assign({}, this.permissaoFields);

        this.permissao = this.hasPermissionAccess('agro', 'agro-planosafra', 'agro-planosafra');

        if ((!this.isUpdate && !this.permissao.create) || (this.isUpdate && !this.permissao.read)) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'agro-planosafra' },
            });
        } else {
            // pega da raiz
            this.carregarEmpresas('');

            if (this.$route.params.id) {
                this.carregarDados(this.$route.params.id);
            }
        }
    },
    watch: {
        planosafra: {
            deep: true,
            handler: function () {
                if (!this.isLoadingEdit) {
                    this.isChanged = true;
                }
            },
        },
        isLoadingEdit(val) {
            // console.log('isLoadingEdit', val);
            // avisa que agora vai poder haver mudanças
            if (this.isUpdate && !val) {
                setTimeout(() => {
                    this.isChanged = false;
                }, 1000);
            }
        },
        updateSituacao(val) {
            if (val) this.promptFinalizar();
        },
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        // Emite ao componente pai se houve alteração em um campo select
        sendIsChanged(label = null) {
            if (!this.isLoadingEdit) this.isChanged = true;
            // Já aproveita e faz as validações
            // console.log('alterou', label);

            if (label == 'empresa') {
                if (this.empresaSelected != null) {
                    this.carregarCliente();
                }
            }
            if (label == 'cultura') {
                if (!this.isLoadingEdit) {
                    this.carregarCultivar();
                    this.cultivarSelected = null;
                    this.niveltecnologicoSelected = null;

                    this.planosafra.previsaoproducao = null;
                    this.planosafra.datasemeadura = null;
                    this.planosafra.qtdeadubacao = null;
                    this.planosafra.colunaespaco = null;
                    this.planosafra.linhaespaco = null;
                    this.planosafra.plantasmetroquadrado = null;
                    this.planosafra.formulaadubacao = null;
                    this.planosafra.idcultivar = null;
                    this.planosafra.idagroniveltecnologico = null;
                    this.planosafra.areatotalplantio = null;
                    this.planosafra.datacolheita = null;
                    this.planosafra.produtividadeobtida = null;

                    this.permissaoFields = Object.assign({}, this.permissaoFieldsClean);
                    this.showFields = false;
                    if (this.culturaSelected != null) {
                        setTimeout(() => {
                            this.loadCulturaPermissao();
                        }, 300);
                    }
                }
            }
            if (label == 'cultura' || label == 'safra' || label == 'empresa') {
                if (!this.isLoadingEdit) {
                    this.niveltecnologicoSelected = null;
                    this.carregarNivelTecnologico();
                }
            }
            if (label == 'niveltecnologico') {
                if (this.isUpdate && this.isLoadingEdit) this.carregarNivelTecnologico(null, true);
            }
            if (label == 'cultivar') {
                if (this.isUpdate && this.isLoadingEdit) this.carregarCultivar(null, true);
            }
        },
        carregarDados(id) {
            this.isLoading = true;
            this.service
                .findByUuid(id)
                .then((body) => {
                    if (body.content) {
                        this.planosafra.idagro_planosafraerp = body.content.idagro_planosafraerp;
                        this.planosafra.uuid = body.content.uuid;
                        this.planosafra.situacao = body.content.situacao;
                        this.planosafra.latitude = body.content.latitude;
                        this.planosafra.longitude = body.content.longitude;
                        this.planosafra.lastfix = body.content.lastfix;
                        this.planosafra.tipogps = body.content.tipogps;
                        this.planosafra.previsaoproducao = body.content.previsaoproducao;
                        this.planosafra.datasemeadura =
                            body.content.datasemeadura != null
                                ? this.$moment(body.content.datasemeadura).toDate()
                                : null;
                        this.planosafra.qtdeadubacao = body.content.qtdeadubacao;
                        this.planosafra.colunaespaco = body.content.colunaespaco;
                        this.planosafra.linhaespaco = body.content.linhaespaco;
                        this.planosafra.plantasmetroquadrado = body.content.plantasmetroquadrado;
                        this.planosafra.formulaadubacao = body.content.formulaadubacao;
                        this.planosafra.idempresa = body.content.idempresa;
                        this.planosafra.idcliente = body.content.idcliente;
                        this.planosafra.idusuario = body.content.idusuario;
                        this.planosafra.idagrosafra = body.content.idagrosafra;
                        this.planosafra.idtipocultura = body.content.idtipocultura;
                        this.planosafra.idcultivar = body.content.idcultivar;
                        this.planosafra.idagroniveltecnologico =
                            body.content.idagroniveltecnologico;
                        this.planosafra.empresa = body.content.empresa;
                        this.planosafra.cultivar = body.content.cultivar;
                        this.planosafra.safra = body.content.safra;
                        this.planosafra.tipocultura = body.content.tipocultura;
                        this.planosafra.cliente = body.content.cliente;
                        this.planosafra.niveltecnologico = body.content.niveltecnologico;
                        this.planosafra.hasagrovisita = body.content.hasagrovisita;
                        this.planosafra.origem = body.content.origem;
                        this.planosafra.datahora = body.content.datahora;
                        this.planosafra.replicapda = body.content.replicapda;
                        if (this.planosafra.formulaadubacao) {
                            let formulaadubacao = this.planosafra.formulaadubacao.split('-');
                            this.formulaadubacao.n = formulaadubacao[0];
                            this.formulaadubacao.p = formulaadubacao[1];
                            this.formulaadubacao.k = formulaadubacao[2];
                        }
                        this.planosafra.areatotalplantio = body.content.areatotalplantio;
                        this.planosafra.datacolheita =
                            body.content.datacolheita != null
                                ? this.$moment(body.content.datacolheita).toDate()
                                : null;
                        this.planosafra.produtividadeobtida = body.content.produtividadeobtida;
                        this.$emit('situacao', this.planosafra.situacao);
                        this.countSelected();
                    } else {
                        if (body.message) {
                            this.$root.showMessage('error', body.message);
                        } else {
                            this.$root.showMessage('error', 'msg-erro-load');
                        }
                        this.$router.push({ name: 'agro-planosafra-list' });
                    }
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load', true);
                })
                .finally(() => {
                    // Bloqueia caso já tenha agro visita vinculada
                    // ou o usuário seja diferente a quem criou
                    if (
                        this.planosafra.hasagrovisita ||
                        this.planosafra.idusuario != this.$store.state.user.usuario.id
                    ) {
                        this.$emit('cantEdit', true);
                    }
                    this.isLoading = false;
                });
        },
        countSelected() {
            // Conta o tando de dados a serem carregados do servidor
            // console.log('countSelected', this.isUpdate, this.isLoadingEdit);
            if (this.isUpdate && this.isLoadingEdit) {
                if (
                    this.planosafra.niveltecnologico &&
                    !this.isNull(this.planosafra.niveltecnologico.descricao)
                ) {
                    this.countToLoad++;
                }
                if (this.planosafra.cultivar && !this.isNull(this.planosafra.cultivar.descricao)) {
                    this.countToLoad++;
                }
                // console.log('countToLoad', this.countToLoad);
                this.fillSelected();
            }
        },
        fillSelected() {
            // preenche os selects com a seleção vinda com os dados da agro visita
            // console.log('fillSelected', this.isUpdate, this.isLoadingEdit);
            if (this.isUpdate && this.isLoadingEdit) {
                if (!this.isNull(this.planosafra.idempresa)) {
                    this.empresaSelected = this.empresaSelect.filter(
                        (f) => f.id == this.planosafra.idempresa
                    )[0];
                }
                if (this.planosafra.cliente && !this.isNull(this.planosafra.cliente.nome)) {
                    this.clienteSelected = {
                        id: this.planosafra.cliente.id,
                        label: this.planosafra.cliente.nome,
                    };
                }
                if (this.planosafra.safra && !this.isNull(this.planosafra.safra.descricao)) {
                    this.safraSelected = {
                        id: this.planosafra.safra.id,
                        label: this.planosafra.safra.descricao,
                    };
                }
                if (
                    this.planosafra.tipocultura &&
                    !this.isNull(this.planosafra.tipocultura.descricao)
                ) {
                    this.culturaSelected = {
                        id: this.planosafra.tipocultura.id,
                        label: this.planosafra.tipocultura.descricao,
                    };
                }
                if (this.culturaSelected != null) {
                    setTimeout(() => {
                        this.loadCulturaPermissao();
                    }, 300);
                }
            }
        },
        fillSelectedComplements() {
            // preenche os selects com a seleção vinda com os dados da agro visita
            // console.log('fillSelected', this.isUpdate, this.isLoadingEdit);
            if (this.isUpdate && this.isLoadingEdit) {
                if (
                    this.planosafra.niveltecnologico &&
                    !this.isNull(this.planosafra.niveltecnologico.descricao)
                ) {
                    this.niveltecnologicoSelected = {
                        id: this.planosafra.niveltecnologico.id,
                        label: this.planosafra.niveltecnologico.descricao,
                    };
                } else {
                    // porque pode vir vazio
                    this.sendIsChanged('niveltecnologico');
                }
                if (this.planosafra.cultivar && !this.isNull(this.planosafra.cultivar.descricao)) {
                    this.cultivarSelected = {
                        id: this.planosafra.cultivar.id,
                        label: this.planosafra.cultivar.descricao,
                    };
                } else {
                    // porque pode vir vazio
                    this.sendIsChanged('cultivar');
                }
            }
        },
        /*
            @84626
            retornar empresas que estão associadas a um usuário informado. Caso o usuário for admin,
            retorna todas as empresas
        */
        carregarEmpresas(q) {
            this.empresasLoading = true;
            this.empresaService
                .findList(q)
                .then((r) => {
                    if (r.status != 200) {
                        console.error(
                            `[PLANO SAFRA - DADOS CADASTRAIS] Erro status ${r.status} ao carregar empresas.`
                        );
                        console.error(`[PLANO SAFRA - DADOS CADASTRAIS] Mensagem: ${r.message}`);
                    } else {
                        this.empresaSelect = r.content.map((e) => {
                            return {
                                id: e.idempresa,
                                label: e.nome,
                            };
                        });
                    }
                })
                .catch((e) => {
                    console.error('[PLANO SAFRA - DADOS CADASTRAIS] Erro ao carregar empresas.', e);
                })
                .finally((_) => {
                    //preenche automaticamente se só tiver um valor
                    if (this.empresaSelect.length == 1 && !this.cantEdit && !this.isLoadingEdit) {
                        this.empresaSelected = this.empresaSelect[0];
                        this.sendIsChanged('empresa');
                    }
                    this.empresasLoading = false;
                });
        },
        carregarCliente(termo = null) {
            if (this.empresaSelected == null) return;

            this.clienteLoading = true;

            let params = [
                // Adicionar filtro complementar
                this.isNull(termo) ? '.*' : this.removeToSearch(termo),
                // parâmetro adicional com o nome do que deve ser filtrado
                this.empresaSelected != null && this.empresaSelected.id ? 'empresa' : null,
                // parâmetro adicional com o id do que deve ser usado no filtro
                this.empresaSelected != null && this.empresaSelected.id
                    ? this.empresaSelected.id
                    : null,
            ];
            this.clientservice
                .findAllCombo(params)
                .then((body) => {
                    return body.content.map((m) => {
                        return {
                            id: m.idcliente,
                            label: m.nome,
                        };
                    });
                })
                .then((r) => {
                    this.clienteSelect = r;
                    //preenche automaticamente se só tiver um valor
                    if (this.clienteSelect.length == 1 && !this.cantEdit && !this.isLoadingEdit) {
                        this.clienteSelected = this.clienteSelect[0];
                        this.sendIsChanged('cliente');
                    }
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa. Termo: [${termo}]`, e);
                })
                .finally(() => {
                    this.clienteLoading = false;
                });
        },
        carregarSafra(termo) {
            this.safraLoading = true;
            this.safraservice
                .findAllCombo(termo)
                .then((body) => {
                    return body.content.map((m) => {
                        return {
                            id: m.idsafra,
                            label: m.descricao,
                        };
                    });
                })
                .then((r) => {
                    this.safraSelect = r;
                    //preenche automaticamente se só tiver um valor
                    if (this.safraSelect.length == 1 && !this.cantEdit && !this.isLoadingEdit) {
                        this.safraSelected = this.safraSelect[0];
                        this.sendIsChanged('safra');
                    }
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa. Termo: [${termo}]`, e);
                })
                .finally(() => {
                    this.safraLoading = false;
                });
        },
        carregarCultura(termo) {
            this.culturaLoading = true;
            this.culturaService
                .findAllCombo(termo)
                .then((body) => {
                    return body.content.map((m) => {
                        return {
                            id: m.idtipocultura,
                            label: m.descricao,
                        };
                    });
                })
                .then((r) => {
                    this.culturaSelect = r;
                    //preenche automaticamente se só tiver um valor
                    if (this.culturaSelect.length == 1 && !this.cantEdit && !this.isLoadingEdit) {
                        this.culturaSelected = this.culturaSelect[0];
                        this.sendIsChanged('cultura');
                    }
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa. Termo: [${termo}]`, e);
                })
                .finally(() => {
                    this.culturaLoading = false;
                });
        },
        carregarNivelTecnologico(termo = null, calledBySend = false) {
            /**
             * utilizado para não carregar os dados ao abrir a página pela função de search do vss.
             * assim só carregará pela primeira vez aós ser preenchido com os dados iniciais
             */
            if (!calledBySend && this.isLoadingEdit) return;

            this.niveltecnologicoLoading = true;
            if (
                this.empresaSelected != null &&
                this.culturaSelected != null &&
                this.safraSelected != null
            ) {
                let params = [
                    // Adicionar filtro complementar
                    // filtro de busca
                    this.isNull(termo) ? '.*' : this.removeToSearch(termo),
                    // parâmetro adicional com o nome do que deve ser filtrado
                    'planosafra',
                    // parâmetro adicional com o id do que deve ser usado no filtro
                    this.empresaSelected.id,
                    this.culturaSelected.id,
                    this.safraSelected.id,
                ];
                this.niveltecnologicoservice
                    .findAllCombo(params)
                    .then((body) => {
                        return body.content.map((m) => {
                            return {
                                id: m.idagroniveltecnologico,
                                label: m.descricao,
                            };
                        });
                    })
                    .then((r) => {
                        this.niveltecnologicoSelect = r;
                        //preenche automaticamente se só tiver um valor
                        if (
                            this.niveltecnologicoSelect.length == 1 &&
                            !this.cantEdit &&
                            !this.isLoadingEdit
                        ) {
                            this.niveltecnologicoSelected = this.niveltecnologicoSelect[0];
                            this.sendIsChanged('niveltecnologico');
                        }
                    })
                    .catch((e) => {
                        console.error(`Erro ao realizar pesquisa. Termo: [${termo}]`, e);
                    })
                    .finally(() => {
                        this.niveltecnologicoLoading = false;
                        this.funcCountLoaded(this.niveltecnologicoSelected);
                    });
            } else {
                // console.log('niveltecnologico erro');
                this.niveltecnologicoLoading = false;
            }
        },
        carregarCultivar(termo = null, calledBySend = false) {
            /**
             * utilizado para não carregar os dados ao abrir a página pela função de search do vss.
             * assim só carregará pela primeira vez aós ser preenchido com os dados iniciais
             */
            if (!calledBySend && this.isLoadingEdit) return;

            this.cultivarLoading = true;
            if (this.culturaSelected != null) {
                let params = [
                    // Adicionar filtro complementar
                    this.isNull(termo) ? '.*' : this.removeToSearch(termo),
                    // parâmetro adicional com o nome do que deve ser filtrado
                    this.culturaSelected != null && this.culturaSelected.id ? 'cultura' : null,
                    // parâmetro adicional com o id do que deve ser usado no filtro
                    this.culturaSelected != null && this.culturaSelected.id
                        ? this.culturaSelected.id
                        : null,
                ];
                this.cultivarService
                    .findAllCombo(params)
                    .then((body) => {
                        return body.content.map((m) => {
                            return {
                                id: m.idcultivar,
                                label: m.descricao,
                            };
                        });
                    })
                    .then((r) => {
                        this.cultivarSelect = r;
                        //preenche automaticamente se só tiver um valor
                        if (
                            this.cultivarSelect.length == 1 &&
                            !this.cantEdit &&
                            !this.isLoadingEdit
                        ) {
                            this.cultivarSelected = this.cultivarSelect[0];
                            this.sendIsChanged('cultivar');
                        }
                    })
                    .catch((e) => {
                        console.error(`Erro ao realizar pesquisa. Termo: [${termo}]`, e);
                    })
                    .finally(() => {
                        this.cultivarLoading = false;
                        this.funcCountLoaded(this.cultivarSelected);
                    });
            } else {
                // console.log('cultivar erro');
                this.cultivarLoading = false;
            }
        },
        loadCulturaPermissao() {
            if (!this.isLoadingEdit) this.isLoading = true;
            this.culturaService
                .find(this.culturaSelected.id)
                .then((r) => {
                    if (r.content) {
                        this.permissaoFields.ativacultivar = +r.content.ativacultivar;
                        this.permissaoFields.ativaniveltecnologico = +r.content
                            .ativaniveltecnologico;
                        this.permissaoFields.ativadatasemeadura = +r.content.ativadatasemeadura;
                        this.permissaoFields.ativaqtdeadubacao = +r.content.ativaqtdeadubacao;
                        this.permissaoFields.ativaformulaadubacao = +r.content.ativaformulaadubacao;
                        this.permissaoFields.ativaplantasmetroquadrado = +r.content
                            .ativaplantasmetroquadrado;
                        this.permissaoFields.ativaareatotalplantio = +r.content
                            .ativaareatotalplantio;
                        this.permissaoFields.ativaprevisaoproducao = +r.content
                            .ativaprevisaoproducao;
                        this.permissaoFields.ativadatacolheita = +r.content.ativadatacolheita;
                        this.permissaoFields.ativaprodutividadeobtida = +r.content
                            .ativaprodutividadeobtida;
                        this.permissaoFields.ativalinhaespaco = +r.content.ativalinhaespaco;
                        this.permissaoFields.ativacolunaespaco = +r.content.ativacolunaespaco;
                        Object.entries(this.permissaoFields).forEach(([key, value]) => {
                            if (value > 0) this.showFields = true;
                        });
                    } else {
                        this.permissaoFields = Object.assign({}, this.permissaoFieldsClean);
                        this.$root.showMessage('error', 'msg-erro-load', true);
                    }
                })
                .catch((e) => {
                    console.error(`Erro ao carregar`, e);
                })
                .finally((_) => {
                    if (!this.isLoadingEdit) this.isLoading = false;
                    this.fillSelectedComplements();
                    if (!this.showFields) this.isLoadingEdit = false;
                });
        },
        successPosition(position) {
            this.planosafra.latitude = position.coords.latitude ? position.coords.latitude : 0;
            this.planosafra.longitude = position.coords.longitude ? position.coords.longitude : 0;
            this.planosafra.lastfix = position.timestamp ? position.timestamp : null;
            this.planosafra.tipogps = position.coords.latitude ? 1 : 0;
        },
        errorPosition(e) {
            console.error('Geolocation error!', e);
        },
        save(situacao = 4) {
            this.planosafra.situacao = situacao;

            this.isLoading = true;
            // pega alocalização através do navegador caso esteja liberado
            if (navigator.geolocation) {
                // console.log('Geolocation is supported by this browser');
                navigator.geolocation.getCurrentPosition(this.successPosition, this.errorPosition);
            } else {
                // console.log('Geolocation is not supported by this browser');
            }
            setTimeout(() => {
                let planosafraTemp = Object.assign({}, this.planosafra);
                if (planosafraTemp.idusuario == null) {
                    planosafraTemp.idusuario = this.$store.state.user.usuario.id;
                }
                planosafraTemp.idempresa =
                    this.empresaSelected != null ? this.empresaSelected.id : null;
                planosafraTemp.idcliente =
                    this.clienteSelected != null ? this.clienteSelected.id : null;
                planosafraTemp.idagrosafra =
                    this.safraSelected != null ? this.safraSelected.id : null;
                planosafraTemp.idtipocultura =
                    this.culturaSelected != null ? this.culturaSelected.id : null;
                planosafraTemp.idagroniveltecnologico =
                    this.niveltecnologicoSelected != null ? this.niveltecnologicoSelected.id : null;
                planosafraTemp.idcultivar =
                    this.cultivarSelected != null ? this.cultivarSelected.id : null;
                planosafraTemp.datasemeadura =
                    planosafraTemp.datasemeadura != null
                        ? this.$moment(planosafraTemp.datasemeadura).format('YYYY-MM-DD')
                        : null;
                if (this.permissaoFields.ativaformulaadubacao > 0) {
                    if (this.formulaadubacao.n) {
                        this.formulaadubacao.n =
                            this.formulaadubacao.n.length > 0
                                ? this.formulaadubacao.n
                                : '0' + this.formulaadubacao.n;
                    }
                    if (this.formulaadubacao.p) {
                        this.formulaadubacao.p =
                            this.formulaadubacao.p.length > 0
                                ? this.formulaadubacao.p
                                : '0' + this.formulaadubacao.p;
                    }
                    if (this.formulaadubacao.k) {
                        this.formulaadubacao.k =
                            this.formulaadubacao.k.length > 0
                                ? this.formulaadubacao.k
                                : '0' + this.formulaadubacao.k;
                    }
                    planosafraTemp.formulaadubacao = `${this.formulaadubacao.n}-${this.formulaadubacao.p}-${this.formulaadubacao.k}`;
                }
                planosafraTemp.datacolheita =
                    planosafraTemp.datacolheita != null
                        ? this.$moment(planosafraTemp.datacolheita).format('YYYY-MM-DD')
                        : null;

                if (
                    this.validation.validate(planosafraTemp, this.permissaoFields, this.$refs) ||
                    situacao == 0
                ) {
                    planosafraTemp = this.mapTosave(planosafraTemp);

                    this.isSaving = true;
                    this.service
                        .save(planosafraTemp)
                        .then((value) => {
                            if (value.message == null) {
                                let msg = this.$t(
                                    this.isUpdate ? 'msg-edit-sucesso-n' : 'msg-save-sucesso-n', 
                                    { n: this.$t('agro-planosafra') }
                                );

                                this.$root.showMessage('success', msg, true, false);

                                // redireciona para a tela de ...... caso venha de lá
                                if (this.$route.query.tela) {
                                    this.redirectToPage();
                                } else if (situacao == 0) {
                                    setTimeout(() => {
                                        this.$router.push({ name: 'agro-planosafra-list' });
                                    }, 1000);
                                } else {
                                    // caso seja atualização de situalção
                                    this.$emit('situacao', this.planosafra.situacao);
                                    // manda para a edição para adicionar os items
                                    this.redirectToEdit(value.content.uuid);
                                }
                                this.$emit('isChanged', false);
                            } else {
                                if (this.$t(value.message)) {
                                    this.$root.showMessage('alert', value.message, true);
                                } else {
                                    this.$root.showMessage(
                                        'error',
                                        'msg-problema-realizar-acao',
                                        true
                                    );
                                }
                            }
                        })
                        .catch(() => {
                            this.$root.showMessage('error', 'msg-problema-realizar-acao', true);
                        })
                        .finally(() => {
                            this.isLoading = false;
                            this.isSaving = false;
                        });
                } else {
                    this.$root.showMessage('alert', 'msg-campos-obrigatorios', true);
                    this.isLoading = false;
                }
            }, 300);
        },
        redirectToEdit(id) {
            setTimeout(() => {
                this.$router.push({
                    name: 'agro-planosafra-edit',
                    params: { id: id },
                });
            }, 1000);
        },
        redirectToPage() {
            let tempTela = null;
            let tempAba = null;
            if (this.$route.query.tela == 'agro-visita') {
                tempTela = 'agro-visita-edit';
                tempAba = 'empresa';
            }
            setTimeout(() => {
                this.$router.push({
                    name: tempTela,
                    params: { id: this.$route.query['id'] },
                    query: { abaSelecionada: tempAba },
                });
            }, 1000);
        },
        funcCountLoaded(objSelected) {
            // adiciona ao contador de dados carregados da edição
            if (this.isLoadingEdit && objSelected != null) {
                this.countLoaded++;
                /**
                 * caso seja edição e o tanto de dados a serem carregados condizer,
                 * avisa que acabou o loading da edição
                 */
                if (this.countToLoad == this.countLoaded) {
                    setTimeout(() => {
                        this.isLoadingEdit = false;
                    }, 1000);
                }
            }
        },
        promptFinalizar() {
            this.$root.confirm({
                message: this.$t('planosafra-confirmacao-finalizacao'),
                onConfirm: () => this.save(1),
                onCancel: () => this.$emit('updateSituacao', false),
            });
        },
        getStartDateColheita() {
            this.startDateColheita = this.planosafra.datasemeadura
                ? this.planosafra.datasemeadura
                : this.$moment().add(-10, 'years').toDate();
            if (
                this.planosafra.datasemeadura &&
                this.planosafra.datacolheita &&
                this.planosafra.datasemeadura > this.planosafra.datacolheita
            ) {
                this.planosafra.datacolheita = null;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.page-container {
    .label-required {
        color: $primary-color;
    }
    .flex-end {
        justify-content: flex-end;
    }
    //classes para o css de espaço por linha/coluna
    .linhaV {
        height: 30px;
        background-color: #818181;
        width: 1px;
        margin-left: 23px;
    }
    .linhaH {
        margin-top: 40px;
        height: 1px;
        background-color: #818181;
        width: 30px;

        @media only screen and (max-width: 768px) {
            height: 30px;
            width: 1px;
            margin-left: 47px;
            margin-top: 0;
        }

        .small-add-spacing {
            @media only screen and (max-width: 768px) {
                padding-left: 1.5rem;
                padding-right: 1.5rem;
            }
        }
    }
    .linhaM {
        margin-left: 24px;
    }
    .small-add-spacing-img {
        @media only screen and (max-width: 768px) {
            padding-left: 1.5rem;
            padding-right: 1.5rem;
        }
    }
    @media only screen and (max-width: 768px) {
        .small-add-spacing-img {
            padding-left: 12px;
        }
        .linhaH {
            margin-left: 35px;
        }
        .linhaM {
            margin-left: 12px;
        }
        .remove-padding {
            padding-left: 0;
            padding-right: 0;
        }
    }
}
</style>
